import dayjs from 'dayjs';
import { DutyHourType } from 'generated';
import { InferType } from 'yup';

import getAddEditDutyCodeSchema from '../utils/addDutyCodeSchema';
import { getMaxDate } from 'utils/date';

export type DutyCodePeriodForm = {
  id: number;
  dutyHourTypeId: number;
  startTime: Date;
  endTime: Date;
  dutyHourType: DutyHourType;
};

export type DutyCodeForm = InferType<
  ReturnType<typeof getAddEditDutyCodeSchema>
>;

export const defaultFormValues: DutyCodeForm = {
  displayDutyCode: '',
  colorCode: '',
  validFrom: new Date(new Date().getFullYear(), 0, 1),
  validTo: getMaxDate(),
  periods: [
    {
      dutyCodePeriodId: undefined,
      startTime: dayjs('1970-01-01T07:00:00Z'),
      endTime: dayjs('1970-01-01T08:00:00Z'),
      dutyHourTypeId: -1
    }
  ],
  description: '',
  flags: {
    ROUTE: false,
    REQUEST_EXCLUDE: false
  }
};
